import { render } from "preact";
import { App } from "./app";
import "./styles.css";
import "./public-site.css";

render(<App />, document.getElementById("app")!);
